import { render, staticRenderFns } from "./videoTailoring.vue?vue&type=template&id=7e996a80&scoped=true&"
import script from "./videoTailoring.vue?vue&type=script&lang=js&"
export * from "./videoTailoring.vue?vue&type=script&lang=js&"
import style0 from "./videoTailoring.vue?vue&type=style&index=0&id=7e996a80&prod&lang=less&scoped=true&"
import style1 from "./videoTailoring.vue?vue&type=style&index=1&id=7e996a80&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e996a80",
  null
  
)

export default component.exports